import BlurIcon from '@atlaskit/icon-lab/core/blur';
import React from 'react';

export function SvgBlur() {
  return <BlurIcon label="" testId="ads-refreshed-icon" />;
}
